import gql from 'graphql-tag'

const mutation = gql`
mutation updateRegion($id: ID!, $fields: RegionInput!) {
	cashAssist {
		updateRegion(id: $id, fields: $fields) {
			id
	    mod_ver
	    name
	    departmentId
		}
	}
}
`
export default mutation
